import { render } from "./WallModeratePost.vue?vue&type=template&id=40c15306&scoped=true"
import script from "./WallModeratePost.vue?vue&type=script&lang=js"
export * from "./WallModeratePost.vue?vue&type=script&lang=js"

import "./WallModeratePost.vue?vue&type=style&index=0&id=40c15306&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-40c15306"

export default script